import type {MarkdownComposerRef} from '@github-ui/commenting/useMarkdownBody'
import {useCurrentRepository} from '@github-ui/current-repository'
import {encodePart} from '@github-ui/paths'
import {useCSRFToken} from '@github-ui/use-csrf-token'
import {verifiedFetch} from '@github-ui/verified-fetch'
import {useRef} from 'react'

import type {CommitComment} from '../../../types/commit-types'
import {CommitCommentEditor} from './CommitCommentEditor'

export function UpdateCommitComment({
  comment,
  commitOid,
  onCancel,
  onUpdate,
}: {
  comment: CommitComment
  commitOid: string
  onCancel: () => void
  onUpdate: (comment: CommitComment) => void
}) {
  const repo = useCurrentRepository()
  const saveUrl = `/${encodePart(repo.ownerLogin)}/${encodePart(repo.name)}/commit_comment`
  const savingToken = useCSRFToken(saveUrl, 'put')

  const commentEditor = useRef<MarkdownComposerRef>(null)

  const onSave = async (markdown: string) => {
    const formData = new FormData()

    formData.append('_method', 'put')
    // eslint-disable-next-line github/authenticity-token
    formData.append('authenticity_token', savingToken!)
    formData.append('commit_comment[id]', comment.id)
    formData.append('commit_comment[body]', markdown)
    formData.append('commit_comment[bodyVersion]', comment.bodyVersion)
    const resonse = await verifiedFetch(saveUrl, {
      method: 'POST',
      body: formData,
    })

    if (resonse.ok) {
      const json = await resonse.json()
      const updatedComment = {
        ...comment,
        body: json.source,
        bodyVersion: json.bodyVersion,
        htmlBody: json.body,
      } as CommitComment
      onUpdate(updatedComment)
    } else {
      // TODO - handle error
    }
  }

  return (
    <CommitCommentEditor
      initialMarkdown={comment.body}
      ref={commentEditor}
      onSave={onSave}
      onCancel={onCancel}
      referenceId={`${commitOid}-${comment.id}`}
      buttonText="Update comment"
    />
  )
}

try{ UpdateCommitComment.displayName ||= 'UpdateCommitComment' } catch {}